module.exports = {
    clients: {
        tableTheBest: {
            title: 'Таблица лучших',
            string: {
                type: 'text-area',
                format: 'text',
                label: 'Строка для пользователя'
            },
            conditions: {
                type: 'conditions',
                items: [],
                label: 'Условия: '
            },
            conditionsCountClients: {
                type: 'conditions',
                items: [],
                label: 'Условия для подсчета: '
            },
            delimiter: {
                type: 'input',
                format: 'text',
                label: 'Разделитель новой строки'
            },
            countLines: {
                type: 'input',
                format: 'number',
                label: 'Количество строк'
            },
            tab: {
                type: 'input',
                format: 'text',
                label: 'Прибавление символа с каждым уровнем'
            },
            itemLabel: {
                type: 'select',
                items: [
                    { value: 0, text: 'Без нумерации' },
                    { value: 1, text: '1. , 1.1., 1.1.1 и т.д.' }
                ],
                label: 'Формат нумерации каждого реферала'
            },
            variableName: {
                type: 'input',
                format: 'text',
                label: 'Переменная, которая будет заменена на отчет. В сообщении нужно указать с фигурными скобками'
            },
            variableIdOne: {
                type: 'selectBox',
                loadValues: 'variables',
                items: [],
                label: 'Список переменных 1'
            },
            sortByOne: {
                type: 'select',
                items: [
                    { value: 0, text: 'Без нумерации' },
                    { value: 1, text: 'По переменной' },
                    { value: 2, text: 'По последнему изменению переменной' }
                ],
                label: 'Сортировать по параметру(1)'
            },
            sortASCOne: {
                type: 'switch',
                label: 'По возрастанию?'
            },
            sortByTwo: {
                type: 'select',
                items: [
                    { value: 0, text: 'Без нумерации' },
                    { value: 1, text: 'По переменной' },
                    { value: 2, text: 'По последнему изменению переменной' }
                ],
                label: 'Сортировать по параметру(2)'
            },
            sortASCTwo: {
                type: 'switch',
                label: 'По возрастанию?'
            },
            variableIdTwo: {
                type: 'selectBox',
                loadValues: 'variables',
                items: [],
                label: 'Список переменных 2'
            },
            numberClient: {
                type: 'switch',
                label: 'Позиция текущего пользователя'
            }
        },
        answerClear: {
            title: 'Очистка состояния клиента'
        },
        updatedAtNow: {
            title: 'Обновить время время клиента'
        },
        referralsForClients: {
            title: 'Таблица рефералов',
            string: {
                type: 'text-area',
                format: 'text',
                label: 'Строка для пользователя'
            },
            delimiter: {
                type: 'input',
                format: 'text',
                label: 'Разделитель новой строки'
            },
            countLines: {
                type: 'input',
                format: 'number',
                label: 'Количество строк (0 если не нужно ограничивать)'
            },
            itemLabel: {
                type: 'select',
                items: [
                    { value: 0, text: 'Без нумерации' },
                    { value: 1, text: '1. , 1.1., 1.1.1 и т.д.' }
                ],
                label: 'Формат нумерации каждого реферала'
            },
            variableName: {
                type: 'input',
                format: 'text',
                label: 'Переменная, которая будет заменена на отчет. В сообщении нужно указать с фигурными скобками'
            },
            lineNumber: {
                type: 'input',
                format: 'number',
                label: 'Количество линий для отображения'
            }
        },
        changeCarNumber: {
            mid: {
                type: 'selectBox',
                loadValues: 'messages',
                label: 'После ввода сообщение'
            }
        },
        changePoints: {
            mid: {
                type: 'selectBox',
                loadValues: 'messages',
                label: 'После ввода сообщение'
            },
            function: {
                type: 'input',
                format: 'text',
                label: 'Логин для входа'
            }
        },
        changePointsRef: {
            mid: {
                type: 'selectBox',
                loadValues: 'messages',
                label: 'После ввода сообщение'
            },
            function: {
                type: 'input',
                format: 'text',
                label: 'Логин для входа'
            }
        },
        changeCarModel: {
            mid: {
                type: 'selectBox',
                loadValues: 'messages',
                label: 'После ввода сообщение'
            }
        }
    },
    fedresurs: {
        getArbitersInfo: {
            title: 'Наполняет карточку арбитра информацией',
            checkCardListId: {
                type: 'selectBox',
                loadValues: 'cardLists',
                label: 'Лист в котором ищем необработанные карточки'
            },
            checkedCardListId: {
                type: 'selectBox',
                loadValues: 'cardLists',
                label: 'Лист в который перемещаем карточку с заполненным профилем'
            }
        },
        arbiterExpiredDealInvalid: {
            title: 'Проверяет просрочку выложенного заявления',
            checkCardListId: {
                type: 'selectBox',
                loadValues: 'cardLists',
                label: 'Лист в котором ищем необработанные карточки'
            },
            expiredCardListId: {
                type: 'selectBox',
                loadValues: 'cardLists',
                label: 'Лист в который перемещаем карточку с просроченными заявлениями о признании сделки должника недействительной'
            },
            updatedAtRefresh: {
                type: 'switch',
                label: 'Обновить время время карточки'
            }
        },
        arbiterExpiredCheck: {
            title: 'Проверяет просрочку с выбором типа сообщения',
            checkCardListId: {
                type: 'selectBox',
                loadValues: 'cardLists',
                label: 'Лист в котором ищем необработанные карточки'
            },
            expiredCardListId: {
                type: 'selectBox',
                loadValues: 'cardLists',
                label: 'Лист в который перемещаем карточку с просроченными заявлениями о признании сделки должника недействительной'
            },
            typeMessage: {
                type: 'select',
                items: [{ value: 1, text: 'Заявление о признании сделки должника недействительной' }, { value: 2, text: 'Уведомление о проведении комитета кредиторов' }],
                label: 'Тип сообщения'
            },
            countDays: {
                type: 'input',
                format: 'number',
                label: 'Разница дней между датой опубликования и датой сообщения'
            },
            conditionType: {
                type: 'select',
                items: [{ value: '==', text: '=' }, { value: '<', text: '<' }, { value: '>', text: '>' }],
                label: 'Условие относительно указанных дней'
            },
            negative: {
                type: 'switch',
                label: 'Дата публикации раньше наступления события?'
            },
            updatedAtRefresh: {
                type: 'switch',
                label: 'Обновить время время карточки'
            }
        }
    },
    moysklad: {
        login: {
            title: 'Логин для входа',
            login: {
                type: 'input',
                format: 'text',
                label: 'Логин для входа'
            },
            password: {
                type: 'input',
                format: 'password',
                label: 'Пароль для входа'
            }
        },
        getProductId: {
            title: 'Поиск товара по заголовку',
            field: {
                type: 'select',
                items: [{ value: 'article', text: 'По артикулу' }],
                label: 'Параметр для поиска'
            },
            pattern: {
                type: 'select',
                items: [{ value: '', text: 'Без шаблона' }, { value: '(', text: '(нужный текст)' }, { value: '{', text: '{нужный текст}' }],
                label: 'Шаблон'
            },
            textToSearchSource: {
                type: 'select',
                items: [{ value: 'market_title', text: 'Заголовок найденного товара' }],
                label: 'Источник текста'
            },
            removeText: {
                type: 'input',
                format: 'text',
                label: 'Удалить лишние символы перед поиском'
            }
        },
        getVariants: {
            title: 'Запрос типов позиции',
            filter: {
                type: 'select',
                items: [{ value: 'productid', text: 'ID продукта' }],
                label: 'Фильтр для поиска'
            },
            sortBy: {
                type: 'input',
                format: 'text',
                label: 'Сортировка по'
            }
        },
        getStockAll: {
            title: 'Запрос остатков позиции',
            sortBy: {
                type: 'input',
                format: 'text',
                label: 'Сортировка по'
            },
            sortDelimiter: {
                type: 'input',
                format: 'text',
                label: 'Разделитель'
            },
            sortCol: {
                type: 'input',
                format: 'text',
                label: 'Разделитель столбцов'
            }
        },
        replaceVariables: {
            title: 'Замена переменных',
            type: 1,
            var: {
                type: 'input',
                format: 'text',
                label: 'Найти текст'
            },
            rep: {
                type: 'input',
                format: 'text',
                label: 'Заменить на'
            }
        }
    },
    botControl: {
        botOff: {
            title: 'Выключение бота',
            addHours: {
                type: 'input',
                format: 'number',
                label: 'На n количество часов'
            }
        },
        botOn: {
            title: 'Включение бота',
            text: {
                type: 'input',
                format: 'text',
                label: 'Фраза для включения'
            },
            delMessage: {
                type: 'switch',
                label: 'Удалить исходящее сообщение?'
            }
        },
        userIds: {
            title: 'Id контролируемых пользователей',
            userIds: {
                type: 'input',
                format: 'text',
                label: 'Перечисленные через запятую id пользователей'
            }
        },
        metrics: {
            title: 'Показатели бота'
        }
    },
    inline: {
        select: {
            title: 'Переводит пользователя для принятия каких либо данных',
            controller: {
                type: 'inlineBox',
                loadValues: '***',
                label: ''
            }
        }
    },
    shop: {
        secretClientVote: {
            title: 'Начать опрос клиента',
            textStart: {
                type: 'input',
                format: 'text',
                label: 'Текст кнопки для начала опроса'
            },
            textCancel: {
                type: 'input',
                format: 'text',
                label: 'Текст кнопки для отмены опроса'
            },
            secretClientId: {
                type: 'selectBox',
                loadValues: 'secretClientVotes',
                label: 'Опросы'
            }
        }
    },
    market: {
        getById: {
            title: 'Поиск товара по идентификатору',
            idSource: {
                type: 'select',
                items: [{ value: 'ref', text: 'Индекс ref в ссылке' }],
                label: 'Источник идентификатора'
            }
        },
        getByVariables: {
            title: 'Условия для переменных',
            market_conditions: {
                type: 'market_conditions',
                label: 'Условия: '
            },
            min_price: {
                type: 'input',
                format: 'text',
                label: 'Минимальная стоимость (Оставьте поле пустым, если не нужно учитывать)'
            },
            max_price: {
                type: 'input',
                format: 'text',
                label: 'Максимальная стоимость (Оставьте поле пустым, если не нужно учитывать)'
            },
            sort: {
                type: 'select',
                items: [
                    { value: 0, text: 'Пользовательская расстановка' },
                    { value: 1, text: 'По дате добавления товара' },
                    { value: 2, text: 'По цене' },
                    { value: 3, text: 'По популярности' }
                ],
                label: 'Сортировка товаров'
            },
            rev: {
                type: 'select',
                items: [
                    { value: 0, text: 'Не использовать обратный порядок' },
                    { value: 1, text: 'Использовать обратный порядок' }
                ],
                label: 'Обратный порядок'
            },
            if_else_selects: {
                type: 'if_else_selects'
            }
        },
        findOffersInYaml: {
            title: 'Поиск позиций в yaml файле',
            url: {
                type: 'input',
                format: 'text',
                label: 'Адрес где хранится файл yaml'
            },
            xPath: {
                type: 'input',
                format: 'text',
                label: 'Поиск по атрибуту (Например: positions/offer)'
            },
            fileName: {
                type: 'input',
                format: 'text',
                label: 'Название файла в которое сохраним yaml файл'
            },
            variablesIds: {
                type: 'combobox',
                loadValues: 'variables',
                label: 'Список переменных, которые участвуют в поиске позиций'
            },
            less: {
                type: 'combobox',
                loadValues: 'variables',
                label: 'Список переменных, которые меньше значения (Например переменная < 1200)'
            },
            more: {
                type: 'combobox',
                loadValues: 'variables',
                label: 'Список переменных, которые больше значения (Например переменная > 1200)'
            },
            lastUpdateVariable: {
                type: 'selectBox',
                loadValues: 'variables',
                label: 'Переменная, в которой хранится время последнего обновления файла yaml'
            },
            count: {
                type: 'selectBox',
                loadValues: 'variables',
                label: 'Переменная, в которой хранится количество найденных позиций'
            },
            messageId: {
                type: 'selectBox',
                loadValues: 'messages',
                label: 'Если позиций 0, то отправится выбранное сообщение'
            },
            stepUpdate: {
                type: 'input',
                format: 'number',
                label: 'Шаг обновления, часы'
            },
            checkKeys: {
                type: 'switch',
                label: 'Анализ переменных и клавиатуры'
            },
            ignoreKeys: {
                type: 'input',
                format: 'text',
                label: 'Исключить кнопки из анализа. Счет начинается с 1, Перечислите через запятую'
            },
            typeMatch: {
                type: 'select',
                items: [
                    { value: 0, text: 'Преобразовать каждое предложение в текст и искать варианты' },
                    { value: 1, text: 'Использовать поля и сравнивать как текст' },
                    { value: 2, text: 'Использовать поля и сравнивать как числа со знаками > или <' }
                ],
                label: 'Тип сравнения для исключения кнопок'
            },
            fields: {
                type: 'input',
                format: 'text',
                label: 'Поля которые сравниваем'
            }
        }
    },
    messages: {
        notification: {
            title: 'Уведомление пользователя о событии',
            userIds: {
                type: 'input',
                format: 'text',
                label: 'Перечисленные через запятую id пользователей'
            },
            vkUserIds: {
                type: 'input',
                format: 'text',
                label: 'ID пользователей, кому нужно переслать сообщение в Вконтакте'
            },
            tgUserIds: {
                type: 'input',
                format: 'text',
                label: 'ID пользователей, кому нужно переслать сообщение в Telegram'
            },
            waUserIds: {
                type: 'input',
                format: 'text',
                label: 'ID пользователей, кому нужно переслать сообщение в WhatsApp'
            },
            useTextInMessage: {
                type: 'switch',
                label: 'Использовать текст, который был написан в сообщении'
            },
            text: {
                type: 'text-area',
                format: 'text',
                label: 'Текст сообщения'
            },
            addAttachment: {
                type: 'switch',
                label: 'Добавить прикрепления'
            },
            forwardMessage: {
                type: 'switch',
                label: 'Прикрепить входящее сообщение (не работает в Telegram)'
            }
        },
        send: {
            title: 'Отправляет любое сообщение',
            vkUserIds: {
                type: 'input',
                format: 'text',
                label: 'ID пользователей, кому нужно отправить сообщение в Вконтакте'
            },
            tgUserIds: {
                type: 'input',
                format: 'text',
                label: 'ID пользователей, кому нужно отправить сообщение в Telegram'
            },
            waUserIds: {
                type: 'input',
                format: 'text',
                label: 'ID пользователей, кому нужно отправить сообщение в WhatsApp'
            },
            messageId: {
                type: 'selectBox',
                loadValues: 'messages',
                label: 'Сообщение'
            }
        },
        sendByMailingGroup: {
            title: 'Отправляет любое сообщение по группе пользователей',
            mailingGroupIds: {
                type: 'combobox',
                loadValues: 'mailing_group',
                items: [],
                label: 'Список групп'
            },
            userIds: {
                type: 'combobox',
                loadValues: 'userIds',
                label: 'Пользователи, кому нужно дополнительно отправить сообщение'
            },
            messageId: {
                type: 'selectBox',
                loadValues: 'messages',
                label: 'Сообщение'
            }
        },
        emailNotification: {
            title: 'Уведомление пользователя о событии на эл. почту',
            emails: {
                type: 'input',
                format: 'text',
                label: 'Перечисленные через запятую эл. почты'
            },
            useTextInMessage: {
                type: 'switch',
                label: 'Использовать текст, который был написан в сообщении'
            },
            theme: {
                type: 'input',
                format: 'text',
                label: 'Тема сообщения'
            },
            text: {
                type: 'text-area',
                format: 'text',
                label: 'Текст сообщения'
            }
        },
        forwardMessage: {
            title: 'Пересылает сообщение пользователям',
            mailingGroupIds: {
                type: 'combobox',
                loadValues: 'mailing_group',
                items: [],
                label: 'Список групп'
            },
            userIds: {
                type: 'combobox',
                loadValues: 'userIds',
                label: 'Пользователи, кому нужно дополнительно отправить сообщение'
            },
            vkUserIds: {
                type: 'input',
                format: 'text',
                label: 'ID пользователей, кому нужно переслать сообщение в Вконтакте'
            },
            tgUserIds: {
                type: 'input',
                format: 'text',
                label: 'ID пользователей, кому нужно переслать сообщение в Telegram'
            },
            waUserIds: {
                type: 'input',
                format: 'text',
                label: 'ID пользователей, кому нужно переслать сообщение в WhatsApp'
            },
            sendAnswer: {
                type: 'switch',
                label: 'Отправить сообщение в ответ, которое предназначалось?'
            },
            text: {
                type: 'text-area',
                format: 'text',
                label: 'Текст сообщения (ВКонтакте)'
            },
            disableNotification: {
                type: 'switch',
                label: 'Тихая отправка без уведомления'
            },
            clientAnswer: {
                type: 'switch',
                label: 'Заменить назначения кнопок от пользователя, которого пришло пересланное сообщение'
            },
            messageIds: {
                type: 'combobox',
                loadValues: 'messages',
                items: [],
                label: 'Список доп. сообщений'
            }
        },
        addMessageToChain: {
            title: 'Добавить в цепочку сообщение при определенном событии',
            messageIds: {
                type: 'combobox',
                loadValues: 'messages',
                items: [],
                label: 'Список сообщений'
            },
            conditions: {
                type: 'conditions',
                items: [],
                label: 'Условия: '
            },
            replace: {
                type: 'switch',
                label: 'Заменить все сообщения в цепочке',
                title: ''
            },
            rnd: {
                type: 'select',
                label: 'Тип смешивания сообщений в цепочке',
                items: [
                    { value: 0, text: 'Без смешивания' },
                    { value: 1, text: 'Случайное одно сообщение из цепочки' },
                    { value: 2, text: 'Перемешивание массива в цепочке' },
                    { value: 3, text: 'Случайное одно ссобщение из всего массива сообщений' },
                    { value: 4, text: 'Перемешивание всех сообщений' }
                ]
            }
        },
        deleteMessagesInHistory: {
            title: 'Удаляет сообщения в очереди',
            vkUserIds: {
                type: 'input',
                format: 'text',
                label: 'ID пользователей, у кого нужно удалить сообщения в Вконтакте'
            },
            tgUserIds: {
                type: 'input',
                format: 'text',
                label: 'ID пользователей, у кого нужно удалить сообщения в Telegram'
            },
            waUserIds: {
                type: 'input',
                format: 'text',
                label: 'ID пользователей, у кого нужно удалить сообщения в WhatsApp'
            }
        },
        checkAttachment: {
            title: 'Проверить наличие прикреплений в следующем сообщении',
            typeFile: {
                type: 'select',
                label: 'Тип файла, который должно содержать сообщение',
                items: [
                    { value: 0, text: 'Фотография' },
                    { value: 1, text: 'Видео' },
                    { value: 2, text: 'Документ' }
                ]
            },
            save: {
                type: 'switch',
                label: 'Сохранить прикрепление в системе (не реализовано)'
            },
            messageIf: {
                type: 'selectBox',
                loadValues: 'messages',
                label: 'Если есть прикрепления, то отправится выбранное сообщение'
            },
            messageElse: {
                type: 'selectBox',
                loadValues: 'messages',
                label: 'Если нет прикреплений, то отправится выбранное сообщение'
            }
        }
    },
    mailing: {
        mainSubscribe: {
            title: 'Общие действия по подпискам',
            value: {
                type: 'select',
                items: [
                    { value: 0, text: 'Подписан на все рассылки' },
                    { value: 1, text: 'Подписан только на групповые рассылки' },
                    { value: 2, text: 'Отписан от рассылок' }
                ],
                label: 'Режим подписки пользователей'
            },
            notification: {
                type: 'switch',
                label: 'Отправить сообщение в ответ?'
            }
        },
        clientChangeSubscribe: {
            title: 'При выполнении происходит изменение подписок',
            group_ids: {
                type: 'combobox',
                loadValues: 'mailing_group',
                items: [],
                label: 'Список групп'
            },
            subscribe: {
                type: 'switch',
                label: 'Отписать/Подписать'
            }
        }
    },
    referral: {
        formSimpleReport: {
            title: 'Формирование простого отчета рефералов',
            inviteString: {
                type: 'text-area',
                format: 'text',
                label: 'Строка для пользователя, который пригласил'
            },
            invitedString: {
                type: 'text-area',
                format: 'text',
                label: 'Строка для пользователя, которого пригласили'
            }
        },
        formSimpleReportForClient: {
            title: 'Отчет по рефераллам (Простой) для пользователей',
            string: {
                type: 'text-area',
                format: 'text',
                label: 'Строка для пользователя'
            },
            countLevel: {
                type: 'input',
                format: 'number',
                label: 'Количество уровней для построения отчета'
            },
            conditions: {
                type: 'conditions',
                items: [],
                label: 'Условия: '
            },
            countClients: {
                type: 'switch',
                label: 'Расчет количества рефералов'
            },
            conditionsCountClients: {
                type: 'conditions',
                items: [],
                label: 'Условия для расчета: '
            },
            delimiter: {
                type: 'input',
                format: 'text',
                label: 'Разделитель новой строки'
            },
            tab: {
                type: 'input',
                format: 'text',
                label: 'Прибавление символа с каждым уровнем'
            },
            itemLabel: {
                type: 'select',
                items: [
                    { value: 0, text: 'Без нумерации' },
                    { value: 1, text: '1. , 1.1., 1.1.1 и т.д.' }
                ],
                label: 'Формат нумерации каждого реферала'
            },
            variableName: {
                type: 'input',
                format: 'text',
                label: 'Переменная, которая будет заменена таблица. В сообщении нужно указать с фигурными скобками'
            }
        }
    },
    variables: {
        conditions: {
            title: 'Переменные',
            conditions: {
                type: 'conditions',
                items: [],
                label: 'Условия: '
            },
            if_else_selects: {
                type: 'if_else_selects'
            }
        },
        moduleConditions: {
            title: 'Модули, которые находятся после этого модуля будут проигнорированны',
            conditions: {
                type: 'conditions',
                items: [],
                label: 'Условия: '
            },
            modulesIf: {
                label: 'Если условие совпало, то переходим к',
                type: 'ifElseSelectsArray'
            },
            modulesElse: {
                label: 'Если условие не совпало, то переходим к',
                type: 'ifElseSelectsArray'
            },
            continueIf: {
                type: 'switch',
                label: 'Продолжить выполнение при совпадении условия?'
            },
            continueElse: {
                type: 'switch',
                label: 'Продолжить выполнение при несовпадении условия?'
            }
        },
        changeVariables: { // автоматизированно без клиента изменяется переменная
            title: 'Изменить переменную',
            variablesIds: {
                type: 'combobox',
                loadValues: 'variables',
                items: [],
                label: 'Список переменных'
            },
            function: {
                type: 'input',
                format: 'text',
                label: 'формула на которую изменяется значение'
            },
            clientIds: {
                type: 'input',
                format: 'text',
                label: 'Напишите id клиентов через запятую (Используйте переменные)'
            }
        },
        changeGlobalVariables: { // автоматизированно без клиента изменяется переменная
            title: 'Изменить переменную',
            variablesIds: {
                type: 'combobox',
                loadValues: 'variables',
                items: [],
                label: 'Список переменных'
            },
            function: {
                type: 'input',
                format: 'text',
                label: 'формула на которую изменяется значение'
            }
        },
        write: { // клиент записывает переменную
            title: 'Изменение переменной клиентом',
            validation: {
                type: 'select',
                items: [
                    { value: 0, text: 'Без валидации' },
                    { value: 1, text: 'Электронная почта' },
                    { value: 2, text: 'Номер телефона' },
                    { value: 3, text: 'Число' }
                ],
                label: 'Формат нумерации каждого реферала'
            },
            variablesIds: {
                type: 'combobox',
                loadValues: 'variables',
                items: [],
                label: 'Список переменных'
            },
            messageIds: {
                type: 'combobox',
                loadValues: 'messages',
                items: [],
                label: 'После успешного ответа, бот отправит сообщения'
            },
            defaultPhrasePhone: {
                type: 'text-area',
                format: 'text',
                label: 'Стандартный ответ, если ввели неверно номер телефона'
            },
            defaultPhraseEmail: {
                type: 'text-area',
                format: 'text',
                label: 'Стандартный ответ, если ввели неверно электронную почту'
            },
            defaultPhraseNumber: {
                type: 'text-area',
                format: 'text',
                label: 'Стандартный ответ, если ввели неверно число'
            },
            keyboardId: {
                type: 'selectBox',
                loadValues: 'keyboards',
                items: [],
                label: 'Клавиатура в сообщении при ошибке ввода'
            }
        }
    },
    card: {
        createOrder: {
            title: 'Создать заказ в группе',
            cardListId: {
                type: 'selectBox',
                loadValues: 'cardLists',
                items: [],
                label: 'Группа в которой создается заказ'
            },
            description: {
                type: 'text-area',
                format: 'text',
                label: 'Описание заказа'
            }
        },
        getBasket: {
            title: 'Создает сообщение с позициями',
            messageId: {
                type: 'selectBox',
                loadValues: 'messages',
                label: 'Сообщение при отмене. Для отмены нужно нажать на 0'
            },
            delimiter: {
                type: 'text-area',
                format: 'text',
                label: 'Разделитель позиций'
            },
            string: {
                type: 'input',
                format: 'text',
                label: 'Строка для показа позиций'
            },
            variable: {
                type: 'input',
                format: 'text',
                label: 'Строка для показа позиций'
            }
        },
        getCardList: {
            title: 'Создать заказ в группе',
            cardListId: {
                type: 'selectBox',
                loadValues: 'cardLists',
                items: [],
                label: 'Группа по которой создается'
            },
            hotKey: {
                type: 'switch',
                label: 'Использовать горячие клавиши для выбора'
            },
            picture: {
                type: 'switch',
                label: 'Картинки (На перспективу)'
            },
            oneMessage: {
                type: 'switch',
                label: 'Все в одном сообщении (в таком случае картинки не будут прикреплены) (На перспективу)'
            },
            messageId: {
                type: 'selectBox',
                loadValues: 'messages',
                items: [],
                label: 'Сообщение при отмене. Для отмены нужно нажать на 0'
            },
            messageViewCard: {
                type: 'selectBox',
                loadValues: 'messages',
                items: [],
                label: 'Сообщение для показа товара'
            },
            messageBackCard: {
                type: 'selectBox',
                loadValues: 'messages',
                items: [],
                label: 'Сообщение при отмене в сообщении для показа товара. Для отмены нужно нажать на 0'
            },
            messageCreateOrder: {
                type: 'selectBox',
                loadValues: 'messages',
                items: [],
                label: 'Сообщение для заполнения описания заказа'
            },
            messageSuccess: {
                type: 'selectBox',
                loadValues: 'messages',
                items: [],
                label: 'Сообщение при успешном добавлении товара в корзину'
            },
            messageError: {
                type: 'selectBox',
                loadValues: 'messages',
                items: [],
                label: 'Сообщение при не успешном добавлении товара в корзину'
            }
        }
    },
    googleDocs: {
        addLine: {
            title: 'Добавить новую строку с информацией',
            string: {
                type: 'text-area',
                format: 'text',
                label: 'Текст(новая строка - новый столбец)'
            },
            url: {
                type: 'input',
                format: 'text',
                label: 'Ссылка на документ'
            },
            listName: {
                type: 'input',
                format: 'text',
                label: 'Название листа'
            },
            offset: {
                type: 'input',
                format: 'number',
                label: 'Смещение по столбцам'
            }
        },
        editLine: {
            title: 'Изменить строку с информацией',
            variableId: {
                type: 'selectBox',
                loadValues: 'variables',
                label: 'Переменная, которая хранит номер строки'
            },
            string: {
                type: 'text-area',
                format: 'text',
                label: 'Текст(новая строка - новый столбец)'
            },
            url: {
                type: 'input',
                format: 'text',
                label: 'Ссылка на документ'
            },
            listName: {
                type: 'input',
                format: 'text',
                label: 'Название листа'
            },
            offset: {
                type: 'input',
                format: 'number',
                label: 'Смещение по столбцам'
            }
        },
        editLineForClientsByVariable: {
            title: 'Изменить строку с информацией по некоторым пользователям',
            variableIdSelect: {
                type: 'selectBox',
                loadValues: 'variables',
                label: 'Переменная, по которой выбираем пользователей'
            },
            value: {
                type: 'input',
                format: 'text',
                label: 'Значение по которому отбираем пользователей'
            },
            variableId: {
                type: 'selectBox',
                loadValues: 'variables',
                label: 'Переменная, которая хранит номер строки'
            },
            string: {
                type: 'text-area',
                format: 'text',
                label: 'Текст(новая строка - новый столбец)'
            },
            url: {
                type: 'input',
                format: 'text',
                label: 'Ссылка на документ'
            },
            listName: {
                type: 'input',
                format: 'text',
                label: 'Название листа'
            },
            offset: {
                type: 'input',
                format: 'number',
                label: 'Смещение по столбцам'
            }
        }
    },
    vk: {
        checkRepost: {
            title: 'Проверить сохранились ли репосты',
            hours: {
                type: 'input',
                format: 'number',
                label: 'Сколько часов должен находиться пост на стене'
            },
            messageId: {
                type: 'selectBox',
                loadValues: 'messages',
                label: 'Сообщение при отсутствии репоста на стене у пользователя'
            }
        }
    },
    binance: {
        getInfo: {
            title: 'Запросить информацию',
            variableIdKey: {
                type: 'selectBox',
                loadValues: 'variables',
                label: 'Переменная, которая хранит api key'
            },
            variableIdSecret: {
                type: 'selectBox',
                loadValues: 'variables',
                label: 'Переменная, которая хранит api secret'
            },
            string: {
                type: 'text-area',
                format: 'text',
                label: 'Как отображать все балансы'
            },
            method: {
                type: 'select',
                items: [
                    { value: 1, text: 'Баланс SPOT' },
                    { value: 2, text: 'Баланс Future' },
                    { value: 3, text: 'Баланс SPOT + Баланс Future' }
                ],
                label: 'Метод'
            },
            asset: {
                type: 'select',
                items: [
                    { value: 1, text: 'BTC' },
                    { value: 2, text: 'USDT' }
                ],
                label: 'Валюта'
            }
        },
        getAllBalances: {
            title: 'Запросить все балансы у пользователей',
            variableIdSelect: {
                type: 'selectBox',
                loadValues: 'variables',
                label: 'Переменная, по которой выбираем пользователей'
            },
            value: {
                type: 'input',
                format: 'text',
                label: 'Значение по которому отбираем пользователей'
            },
            variableIdSaveValue: {
                type: 'selectBox',
                loadValues: 'variables',
                label: 'Переменная, в которую запишем переменные'
            },
            variableIdKey: {
                type: 'selectBox',
                loadValues: 'variables',
                label: 'Переменная, которая хранит api key'
            },
            variableIdSecret: {
                type: 'selectBox',
                loadValues: 'variables',
                label: 'Переменная, которая хранит api secret'
            },
            method: {
                type: 'select',
                items: [
                    { value: 1, text: 'Баланс SPOT' },
                    { value: 2, text: 'Баланс Future' },
                    { value: 3, text: 'Баланс SPOT + Баланс Future' }
                ],
                label: 'Метод'
            },
            asset: {
                type: 'select',
                items: [
                    { value: 1, text: 'BTC' },
                    { value: 2, text: 'USDT' }
                ],
                label: 'Валюта'
            }
        }
    }
}
/*
groupName: {
    groupType: {
        title: 'groupTypeTitle'
        type: 1 * - numbers,
        groupElement: {
            type: '',
            format: '',
            label: ''
        }
    }
}
*/
